// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"137":"query","406":"investors","449":"companyOnePager","979":"investorSearch"}[chunkId] + "." + {"137":"fb819f68","406":"c36b79a4","449":"e5168b7f","979":"a54da2c7"}[chunkId] + ".css";
};